"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@engaging-tech/components");
var currentYear = new Date().getFullYear();

/**
 * Copyright disclaimer. Will always show the current year (depending on a visitor's locale.)
 * @package
 */
var Copyright = function Copyright(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement(_components.Text, {
    width: "auto"
  }, currentYear, "\xA9 ", name);
};
var _default = exports["default"] = Copyright;